// ----------------------------------------------------------------------
// <copyright file="Izenda.BoardList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Board List
 */

!(function() {
  var m = require('mobx');
  const { isArray, isEmpty, map } = require('lodash/fp');

  var CategoryDetail = require('logic/models/Izenda.CategoryDetail');
  var LazyLoadingUtils = require('share/utils/Izenda.LazyLoadingUtils');

  module.exports = function(constants, itemsFieldName) {
    var defaultSearchText = '';
    function BoardList() {
      var props = {
        isLastPage: false,
        categories: [], // Array of CategoryDetail
        searchType: constants.SEARCH_CRITERIA[0].value,
        searchText: defaultSearchText,
        sortBy: constants.SORT_CRITERIA[0].value,
        sortDir: constants.SORT_TYPES.ASC,
        isEmpty: function() {
          var isEmptyCategory = true;
          for (var i = 0; i < this.categories.length; i++) {
            if (!this.categories[i].isEmpty) {
              isEmptyCategory = false;
              break;
            }
          }
          return isEmptyCategory;
        }
      };

      m.extendObservable(this, props);
    }

    /**
     * Update search item
     * @param  {String} searchType
     */
    BoardList.prototype.setSearchType = function(searchType) {
      this.setProperty('searchType', searchType || constants.SEARCH_CRITERIA[0].value);
    };

    /**
     * Update search value
     * @param  {String} searchText
     */
    BoardList.prototype.setSearchText = function(searchText) {
      this.setProperty('searchText', searchText || defaultSearchText);
    };

    /**
     * Update sort item
     * @param  {String} sortBy
     */
    BoardList.prototype.setSortBy = function(sortBy) {
      this.setProperty('sortBy', sortBy);
    };

    /**
     * Update sort direction
     * @param  {String} sortDir
     */
    BoardList.prototype.setSortDir = function(sortDir) {
      this.setProperty('sortDir', sortDir);
    };

    /**
     * Update search information.
     * @param  {String} searchType
     * @param  {String} searchText
     * @param  {String} sortBy
     */
    BoardList.prototype.setSearchInfo = m.action(function(searchType, searchText, sortBy) {
      searchType && this.setSearchType(searchType);
      this.setSearchText(searchText);
      sortBy && this.setSortBy(sortBy);
    });

    /**
     * Set value for property by its name
     * @param  {String} key
     * @param  {Object} value
     */
    BoardList.prototype.setProperty = function(key, value) {
      this[key] = value;
    };

    /**
     * Populate categories
     * @param {Array} data
     */
    BoardList.prototype.readBoardList = m.action(function(data) {
      data = data || [];

      if (isArray(data) && !isEmpty(data)) {
        this.categories = data.map(function(item) {
          return new CategoryDetail(item);
        });
      } else {
        this.categories = [];
      }
    });

    /**
     * Update display state for all board items
     * @param  {Boolean} state
     */
    BoardList.prototype.toggleReportExpandAll = m.action(function(state) {
      this.categories.forEach(function(groupCategory) {
        groupCategory.subCategories &&
          groupCategory.subCategories.forEach(function(category) {
            category.subCategories &&
              category.subCategories.forEach(function(subCategory) {
                subCategory[itemsFieldName].forEach(function(board) {
                  board.setStateExpanded && board.setStateExpanded(state);
                });
              });
          });
      });
    });

    /**
     * Reset subscribe all categories
     */
    BoardList.prototype.resetSubscribes = m.action(function() {
      this.categories.forEach(function(groupCategory) {
        // Reset subscription of itself
        groupCategory.resetSubscribes && groupCategory.resetSubscribes();

        // Reset subscription of its children categories
        groupCategory.subCategories &&
          groupCategory.subCategories.forEach(function(category) {
            category.resetSubscribes && category.resetSubscribes();
          });
      });
    });

    /**
     * Poplate data
     * @param {Array} result
     * @param {Boolean} isReset
     * @param {Object} treeMap
     */
    BoardList.prototype.populate = m.action(function(result, isReset, treeMap) {
      var data = result.data;

      var categories = map(function(item) {
        var category = new CategoryDetail();
        category.populateDataForGlobalLocalCategory(item);
        return category;
      }, data);

      if (isReset) {
        this.categories.splice(0, this.categories.length);
      }

      this.isLastPage = result.isLastPage;
      LazyLoadingUtils.concatTree(this.categories, categories, treeMap, result.numOfChilds, []);
    });

    return BoardList;
  };
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.BoardList.js